import { NET_ID } from "@/config";
import { get } from ".";

/**
 * 在这里统一根据链id切换请求不同链的代码
 */
export async function getChainsTokens() {
  let tokenListUrl = "";

  if ([56, 97].includes(NET_ID)) {
    tokenListUrl =
      "https://tokens.pancakeswap.finance/pancakeswap-extended.json";
  }

  if ([8453, 84532].includes(NET_ID)) {
    // tokenListUrl =
    //   "https://tokens.pancakeswap.finance/pancakeswap-extended.json";
    return { tokens: [] };
  }

  if ([1, 11155111].includes(NET_ID)) {
    // tokenListUrl =
    //   "https://tokens.pancakeswap.finance/pancakeswap-extended.json";
    return { tokens: [] };
  }

  return await get(tokenListUrl, {});
}
